import {CSSProperties} from '../../../styleSheet';
import {withCaching} from '../../../utils';
import {getStyleCategories} from '../functions';

import {StyleCategoryName, BaseAllCategoryProps} from '../types';

import {isEmptyStyle} from './';

const getStylePropertiesFromCategoriesAndCustomStyleInternal = (
  categories: StyleCategoryName[],
  props: BaseAllCategoryProps,
  customStyle?: CSSProperties,
): CSSProperties | undefined => {
  const styleCategories = getStyleCategories(categories, props);

  const styles: CSSProperties = {
    ...styleCategories,
    ...customStyle,
  };

  return isEmptyStyle(styles) ? undefined : styles;
};

export const getStylePropertiesFromCategoriesAndCustomStyle = withCaching(
  getStylePropertiesFromCategoriesAndCustomStyleInternal,
);
